// extracted by mini-css-extract-plugin
export default {"pagerButton":"WeekPager_pagerButton__sFtpT","weekRange":"WeekPager_weekRange__YO4jv"};